// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__qO8Am","comment":"styles_comment__Ql0nv"};